export default __webpack_public_path__ + "images/A9.b6ff29c.png";